export * from './locale-date.pipe';
export * from './distance-in-words-translate.pipe';
